import classnames from 'classnames/bind'
import React from 'react'

import RichText, { RichTextBlock } from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface ArticleTitleProps {
  className?: string
  subtitle?: RichTextBlock[]
  label?: RichTextBlock[]
}

function ArticleTitle({ className, subtitle, label }: ArticleTitleProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })
  const subtitleStyle = useStyle({ textPreset: 'title-section-page' })
  const labelStyle = useStyle({ textPreset: 'title-content' })

  return (
    <section className={cx(css.ArticleTitle, className)}>
      <div className={gridStyle}>
        {subtitle && (
          <RichText
            className={cx(css.subtitle, subtitleStyle)}
            render={subtitle}
          />
        )}
        {label && label?.length > 0 && (
          <RichText className={cx(css.label, labelStyle)} render={label} />
        )}
      </div>
    </section>
  )
}

ArticleTitle.defaultProps = {}

export default ArticleTitle
